import { ReactComponent as AddPlusIcon } from "../../../../assets/icons/add-plus-icon.svg";
import { ReactComponent as GalleryIcon } from "../../../../assets/icons/gallery-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete-icon-new.svg";
import { handleUploadImage } from "../../../../constants";
import LineText from "../../../../Libraries/LineText";
import { UBAppModal } from "../../../../Libraries";
import React, { useState } from "react";
import I18n from "../../../../languageConfig";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const DisplayImageItem = ({
  setSelected = () => { },
  handleSetImage,
  currentImage,
  selected,
  onDelete,
  img,
  ind,
}) => {

  const [isHovered, setIsHovered] = useState(false);

  const handleUpload = (e) => {
    let photos = e.target.files?.[0];
    triggerLogEvent(analytics, "sb_image_uploaded", { index: ind });
    handleUploadImage(photos, (result) => {
      handleSetImage({
        image_url: result,
        image_val: img,
      });
      setSelected(ind);
    });
  };

  const handleIconClick = () => document?.getElementById(`variant-image-add-${ind}`)?.click?.();

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    handleSetImage(null);
    if (
      currentImage?.imageLibIndex == null ||
      currentImage?.imageLibIndex === ind
    ) {
      setSelected(null);
    }
    onDelete(ind);
  };


  const onImageHover = (val = false) => {
    setIsHovered(val);
  };

  return (
    <div
      className={
        !img
          ? "add-img-item"
          : `img-select-item ${selected === ind ? "selected" : ""}`
      }
      onClick={img ? () => { setSelected(ind); } : handleIconClick}
      onMouseLeave={onImageHover.bind(this, false)}
      onMouseEnter={onImageHover.bind(this, true)}
      role="button"
    >
      {img ? (
        <div className="w-100 d-flex align-items-center justify-content-center">
          <div
            className={`delete-hover-add-modal-image ${isHovered ? "" : "delete-not-hover"
              }`}
            onClick={(e) => handleDeleteClick(e)}
          >
            <DeleteIcon />
          </div>
          <img src={img.image_url} className="add-modal-image" />
        </div>
      ) : (
        <AddPlusIcon />
      )}
      <input
        onChange={handleUpload}
        accept="image/*"
        id={`variant-image-add-${ind}`}
        className="variant-color-inp"
        type="file"
        hidden
      />
    </div>
  );
};
const ImageAddModal = ({
  ImgArr = [1, 2, 3, 4, 5, 6, 7],
  show = false,
  handleClose,
  currentImage,
  setImageArr,
  onCancel,
  onSave,
}) => {
  const [selected, setSelected] = useState(null);

  React.useEffect(() => {
    let isImg = currentImage?.images?.[0];
    if (isImg) {
      setSelected(isImg?.imageLibIndex);
    } else {
      setSelected(null);
    }
  }, [show]);

  const modalButtons = [
    {
      data: {
        className: "ubSecondaryButton",
        title: I18n.cancel,
        onClick: onCancel,
        id: `image_add_cancel`,
      },
    },
    {
      data: {
        className: "ubPrimaryButton",
        title: I18n.save,
        onClick: () => {
          triggerLogEvent(analytics, "sb_image_add_saved", { selected_index: selected });
          if (selected != null && selected !== -1) {
            onSave(selected);
            setSelected(null);
          } else {
            onCancel();
          }
        },
        id: `image_add_confirm`,
      },
    },
  ];
  return (
    <UBAppModal
      id="image_add_modal"
      open={show}
      header={{
        handleClose: handleClose,
        dont_show_cross_icon: true,
        title: I18n.variant_image
      }}
      className={styles.ImageAddModalContainer}
      footer={modalButtons}
    >
      <div className="image-disp">
        {selected !== null ? (
          <img
            src={
              ImgArr?.[selected]?.image_url || currentImage?.images?.[0]?.image
            }
            className="add-modal-image-show"
          />
        ) : (
          <GalleryIcon height={"6.4rem"} width={"6.4rem"} />
        )}
      </div>
      <div className="image-adder">
        <LineText className="mb-3">
          Select variant image from the product images
        </LineText>
        <div className="d-flex align-items-center justify-content-start gap-2 variant_add_img_container">
          {ImgArr.map((img, ind) => (
            <DisplayImageItem
              key={ind}
              img={img}
              selected={selected}
              setSelected={setSelected}
              ind={ind}
              handleSetImage={(img) => {
                const cloneImg = [...ImgArr];
                cloneImg[ind] = img;
                setImageArr(cloneImg);
              }}
              onDelete={(deleteInd) => onSave(deleteInd, "DELETE")}
              currentImage={currentImage?.images?.[0]}
            />
          ))}
        </div>
      </div>
    </UBAppModal>
  );
};

export default ImageAddModal;
